module.exports = __webpack_public_path__ + "static/media/medium.7cb412f6.svg";